import { computed, Ref } from 'vue'

import { PatientType } from '@/types'
import { useApi } from '@/utils'

export function useGetSearchResults() {
  const { apiFetch } = useApi()

  const getSearchResults = (query: Ref<string>) =>
    apiFetch<PatientType[]>({
      url: computed(() => `/search?query=${query.value}`),
      method: 'GET',
      useFetchOptions: { immediate: false },
    })

  return { getSearchResults }
}
